import {
  fetchList,
  handleFileUpload,
  handleFileDownload,
  getFileProcess,
  LoginUrl,
  fetchTablesUrl,
  fetchTableDataUrl,
  updatePasswordUrl,
  fetchAllVendorsUrl,
  fetchPreviewVendorsUrl,
  searchVendorsUrl,
  fetchAllList,
  fetchAllSubmittedList,
  logoutUrl,
  getLookerEmbedUrl,
  getSidebarMenusUrl,
  getFirebaseCredentialsUrl,
  getFileSizeLimitUrl,
  updateFileSizeLimitUrl,
  getFeatureFlagsUrl,
  submitFileUrl,
  submitFileWithEmailsUrl,
  submitFeedbackUrl  
} from "./environment.dev";
import responseParse from "./responseParser";
import { interceptor } from "./interceptor";

// const getFilesAction=
export const getFilesAction = "fetchList";
export const uploadFileAction = "uploadFile";
export const downloadFileAction = "downloadFile";
export const getFileUploadResponseAction = "getFileUploadResponse";
//const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

const getFiles = async () => {
  return interceptor(`${fetchList}?max_downloads=6`, {
    method: "GET",
    timeout: 50000,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};

const getAllFiles = async (pageNo = 0, max_downloads) => {
  return interceptor(
    `${fetchAllList}?max_downloads=${max_downloads}&page=${pageNo}`,
    {
      method: "GET",
      timeout: 50000,
    }
  )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};
const getAllSubmittedFiles = async (pageNo = 0, max_downloads) => {
  return interceptor(
    `${fetchAllSubmittedList}?max_downloads=${max_downloads}&page=${pageNo}`,
    {
      method: "GET",
      timeout: 50000,
    }
  )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};

// const checkFileProcess = async (id) => {
//   return interceptor(`${getFileProcess}?file_id=${id}`, {
//     method: "POST",
//     // body: ,
//     timeout: 300000,
//   })
//     .then((response) => {
//       return response.data;
//     })
//     .catch((error) => {
//       return responseParse(error.response);
//     });
// };

const checkFileProcess = async (id) => {
  return interceptor(`${getFileProcess}?file_id=${id}`, {
    method: "POST",
    timeout: 300000, // 5 minutes
  })
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        console.warn(" Response data is empty");
        throw new Error("Empty response from server");
      }
    })
    .catch((error) => {
      console.error(" API ERROR:", error);
      console.error(" ERROR RESPONSE:", error.response);
      console.error(" ERROR STATUS:", error.response?.status);
      console.error(" ERROR DATA:", error.response?.data);
      console.error(" ERROR CODE:", error.code);
      console.error(" ERROR NAME:", error.name);
      
      // Handle different types of errors BEFORE calling responseParse
      if (error.isTimeout || error.code === 'TIMEOUT' || error.name === 'AbortError') {
        throw new Error("File is still being processed. Please wait a moment and try again.");
      }
      
      if (error.code === 'ECONNABORTED') {
        throw new Error("Request timeout - file is still being processed. Please try again in a moment.");
      }
      
      if (!error.response) {
        // Network error or other issues without a response
        throw new Error("Network connection error. Please check your connection and try again.");
      }
      
      // Only call responseParse if we have a valid error.response
      return responseParse(error.response);
    });
};


const uploadFile = async (file, region) => {
  let formdata = new FormData();

  if (file) formdata.append("file", file);
  return interceptor(`${handleFileUpload}?region=${region}`, {
    method: "POST",
    body: formdata,
    timeout: 50000,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};

// const downloadFileReq = async (id, filename, fileFormat) => {
//   return interceptor(`${handleFileDownload}?file_id=${id}&type=${fileFormat}`, {
//     method: "POST",
//     timeout: 50000,
//     responseType: "blob"
//   })
//     .then((response) => {
//       const blobData = new Blob([response.data], {
//         type: (fileFormat === 'csv') 
//               ? "text/csv"
//               : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//       });
//       const url = window.URL.createObjectURL(blobData);
//       const link = document.createElement("a");
//       link.href = url;
//       // rename file to csv
//       if (fileFormat === "csv") filename = filename.replace(".xlsx",".csv")
//       link.setAttribute("download", filename);
//       document.body.appendChild(link);
//       link.click();
//     })
//     .catch((error) => {
//       error.response.data.detail = "Error: Processing Incomplete or Invalid File"
//       return responseParse(error.response);
//     });
// };

const downloadFileReq = async (id, filename, fileFormat) => {
  return interceptor(`${handleFileDownload}?file_id=${id}&type=${fileFormat}`, {
    method: "POST",
    timeout: 50000,
    responseType: "blob"
  })
    .then((response) => {
      console.log("=== DOWNLOAD SUCCESS ===");
      console.log("Response received, creating blob...");
      
      const blobData = new Blob([response.data], {
        type: (fileFormat === 'csv') 
              ? "text/csv"
              : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const url = window.URL.createObjectURL(blobData);
      const link = document.createElement("a");
      link.href = url;
      // rename file to csv
      if (fileFormat === "csv") filename = filename.replace(".xlsx",".csv")
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      
      console.log("Download link clicked successfully");
      
      // Clean up
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      }, 100);
      
      // Return success indicator
      return { success: true, filename: filename };
    })
    .catch((error) => {
      console.error("=== DOWNLOAD ERROR ===");
      console.error("Error details:", error);
      
      // Don't modify the error response, just throw it
      throw error;
    });
};

const loginReq = (body) => {
  return interceptor(`${LoginUrl}`, {
    method: "POST",
    body: body,
    timeout: 50000,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};
const getTableName = async () => {
  return await interceptor(`${fetchTablesUrl}`, {
    method: "GET",
    timeout: 50000,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};

const getTableData = async (tableKey, pageNo, limit) => {
  return interceptor(
    `${fetchTableDataUrl}?table_name=${tableKey}&page=${pageNo}&limit=${limit}`,
    {
      method: "GET",
      timeout: 50000,
    }
  )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};

const getLookerEmbed = async () => {
  return interceptor(`${getLookerEmbedUrl}`, {
    method: "GET",
    timeout: 50000,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};

const getSidebarMenus = async () => {
  return interceptor(`${getSidebarMenusUrl}`, {
    method: "GET",
    timeout: 50000,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};

const getFeatures = async () => {
  return interceptor(`${getFeatureFlagsUrl}`, {
    method: "GET",
    timeout: 50000,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
}

// const createUser = async (body) => {
//   return interceptor(`${createUserUrl}`, {
//     method: "POST",
//     body: JSON.stringify(body),
//     timeout: 50000,
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//       "ForgeRock Token": sessionStorage.getItem("forgerock_token") || ""
//     },
//   })
//     .then((response) => {
//       return response.data;
//     })
//     .catch((error) => {
//       return responseParse(error.response);
//     });
// };
// const updateUser = async (body) => {
//   return await interceptor(`${updateUserUrl}`, {
//     method: "POST",
//     body: JSON.stringify(body),
//     timeout: 50000,
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   })
//     .then((response) => {
//       return response.data;
//     })
//     .catch((error) => {
//       return responseParse(error.response);
//     });
// };

// const deleteUser = async (body) => {
//   return interceptor(`${deleteUserUrl}`, {
//     method: "POST",
//     body: JSON.stringify(body),
//     timeout: 50000,
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   })
//     .then((response) => {
//       return response.data;
//     })
//     .catch((error) => {
//       return responseParse(error.response);
//     });
// };

const updatePassword = async (body) => {
  return interceptor(`${updatePasswordUrl}`, {
    method: "POST",
    body: JSON.stringify(body),
    timeout: 50000,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};
// const getAllUser = async () => {
//   return await interceptor(`${fetchAllUsersUrl}`, {
//     method: "GET",
//     timeout: 50000,
//   })
//     .then((response) => {
//       return response.data;
//     })
//     .catch((error) => {
//       return responseParse(error.response);
//     });
// };

const getAllVendors = async () => {
  return interceptor(`${fetchAllVendorsUrl}`, {
    method: "GET",
    timeout: 50000,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};

const getPreviewVendors = async () => {
  return interceptor(`${fetchPreviewVendorsUrl}`, {
    method: "GET",
    timeout: 50000,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};

const getVendorSearchResult = async (input) => {
  return interceptor(`${searchVendorsUrl}?input=${input}`, {
    method: "GET",
    timeout: 50000,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};

const logout = async () => {
  return interceptor(`${logoutUrl}`, {
    method: "POST",
    timeout: 50000,
    headers: {
      "ForgeRock-Token": sessionStorage.getItem("forgerock_token") || "",
      "ForgeRock-IdToken": sessionStorage.getItem("idToken") || ""
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};


const getFirebaseCredentials = async () => {
  return interceptor(`${getFirebaseCredentialsUrl}`, {
    method: "GET",
    timeout: 50000,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};

const getFileSizeLimit = async () => {
  return interceptor(`${getFileSizeLimitUrl}`, {
    method: "GET",
    timeout: 50000,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};

const updateFileSizeLimit = async (fileSize) => {
  return interceptor(`${updateFileSizeLimitUrl}?file_size=${fileSize}`, {
    method: "POST",
    timeout: 50000,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};

const submitFile = async (fileId) => {
  return interceptor(`${submitFileUrl}?file_id=${fileId}`, {
    method: "POST",
    timeout: 50000,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};
const submitFileWithEmails = async (submissionData) => {
  return interceptor(`${submitFileWithEmailsUrl}`, {
    method: "POST",
    body: JSON.stringify(submissionData),
    timeout: 50000,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};

const submitFeedback = async (feedbackData) => {
  return interceptor(`${submitFeedbackUrl}`, {
    method: "POST",
    body: JSON.stringify(feedbackData),
    timeout: 50000,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return responseParse(error.response);
    });
};


// const downloadAllUsers = async () => {
//   const response = await interceptor(`${downloadAllUsersUrl}`, {
//     method: "GET",
//     timeout: 50000,
//   }).then((res) => {
//     return res.blob();
//   });
//   const url = window.URL.createObjectURL(response);
//   const link = document.createElement("a");
//   link.href = url;
//   link.setAttribute("download", "Userslist");
//   document.body.appendChild(link);
//   link.click();
// };
export default {
  getFiles,
  uploadFile,
  downloadFileReq,
  checkFileProcess,
  loginReq,
  getTableName,
  getTableData,
  updatePassword,
  getAllVendors,
  getPreviewVendors,
  getVendorSearchResult,
  getAllFiles,
  getAllSubmittedFiles,
  logout,
  getLookerEmbed,
  getSidebarMenus,
  getFirebaseCredentials,
  getFileSizeLimit,
  updateFileSizeLimit,
  getFeatures,
  submitFile,
  submitFileWithEmails, 
  submitFeedback  
};
